/**
 * @generated SignedSource<<7a470bb41c45e4629011c7d62479a8a8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ClientAssignee_applianceAssignee$data = {
  readonly assignee: {
    readonly id: string;
    readonly name: string;
  } | null;
  readonly id: string;
  readonly " $fragmentType": "ClientAssignee_applianceAssignee";
};
export type ClientAssignee_applianceAssignee$key = {
  readonly " $data"?: ClientAssignee_applianceAssignee$data;
  readonly " $fragmentSpreads": FragmentRefs<"ClientAssignee_applianceAssignee">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ClientAssignee_applianceAssignee",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "assignee",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Appliance",
  "abstractKey": null
};
})();

(node as any).hash = "9a90f1d52baae5a1591fcf8df4fa61de";

export default node;
